import { render } from "./cell_list.vue?vue&type=template&id=2bdedda5"
import script from "./cell_list.vue?vue&type=script&lang=ts"
export * from "./cell_list.vue?vue&type=script&lang=ts"
script.render = render

export default script